import buildUrl from '../utils/buildUrl';
import { securityBaseUrl } from './baseUrl';

export const changeUserPasswordRoute = (userId: number) =>
  buildUrl({
    url: `${securityBaseUrl}/security/users/${userId}/password`,
  });
